import { useState } from "react";

import { CircularProgress, InputAdornment, TextField } from "@mui/material";
import { getZipCodeAddress } from "../../Services/locationsService";

const InputZipCodeTextField = ({
  setValue,
  name,
  handleSetAddressValues,
  ...props
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");

  const handleZipChange = async (e) => {
    const zip = e.target.value;

    setValue(zip);
    setError("");

    if (/^\d{5}$/.test(zip)) {
      setIsLoading(true);

      handleSetAddressValues("", ""); // Clear address before new fetch

      try {
        const response = await getZipCodeAddress(zip);
        handleSetAddressValues(
          zip,
          response.placeName,
          response.stateAbbreviation
        );
      } catch (err) {
        setError("Invalid ZIP Code");
      } finally {
        setIsLoading(false);
      }
    } else {
      setError("Please enter a valid value");
      handleSetAddressValues("", "", "");
    }
  };

  return (
    <TextField
      id={name}
      name={name}
      fullWidth
      onChange={handleZipChange}
      error={Boolean(error)}
      helperText={error}
      inputProps={{ maxLength: 5 }}
      InputProps={{
        endAdornment: isLoading ? (
          <InputAdornment position="end">
            <CircularProgress size={20} />
          </InputAdornment>
        ) : null,
      }}
      {...props}
    />
  );
};

export default InputZipCodeTextField;
